// extracted by mini-css-extract-plugin
export default {"container":"CommonNotificationStyles_container__j3x3d","fileName":"CommonNotificationStyles_fileName__oZ9p1"};